import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/landing/Nav";
import { Hero } from "./components/landing/Hero";
import { About } from "./components/landing/About";
import { ACM } from "./components/landing/ACM";
import { OpenLetter } from "./components/landing/OpenLetter";
import { Testimonials } from "./components/landing/Testimonials";
import { WhistleCessation } from "./components/landing/WhistleCessation";
import { Priorities } from "./components/landing/Priorities";
import { Contact } from "./components/landing/Contact";
import { Donors } from "./components/landing/Donors";
import { Footer } from "./components/landing/Footer";
import "@/App.css";

function App() {
  return (
    <div className="App bg-[#F4F4F0] text-[#111111] font-sans antialiased selection:bg-[#111111] selection:text-[#F4F4F0]">
      <Nav />
      <main>
        <Hero />
        <About />
        <ACM />
        <OpenLetter />
        <Priorities />
        <Testimonials />
        <WhistleCessation />
        <Contact />
        <Donors />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
